import {Navigate} from "react-router-dom";
import {accountService} from "@/_services/account.service";

const LoginGuard = ({children}) => {
    let logged = accountService.isLogged()

    if(logged){
        return <Navigate to="/"/>
    }

    return children
};

export default LoginGuard;
